import {
    ApiBaseService,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type { Template } from "~/models/Template";
import { useAppLogoUrl } from "~/utils";

export interface UseTemplateOptions {
    response_format: "navigate" | "resource";
}

export default class TemplateService extends ApiBaseService {
    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<Template> {
        return this.paginate<Template>(
            this.route("api.templates.index", "/templates"),
            options as PaginatedFetchOptions,
        );
    }

    public createEmpty(
        type: Template["type"],
        template: Partial<Omit<Template, "type">> = {},
    ): Template {
        return useMergeWith(
            {
                id: 0,
                is_featured: false,
                type,
                app: {
                    label: "HireData",
                    icon: useAppLogoUrl({ type: "icon" }),
                    logo: useAppLogoUrl(),
                    value: "hiredata",
                },
                banner: "",
                title: "",
                slug: "",
                description: "",
                tags: [],
                show_anyways: false,
                urls: {
                    use: "",
                },
                metadata: {},
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
            },
            template,
        );
    }

    async use(template: Template, options?: Partial<UseTemplateOptions>) {
        return this.request(template.urls.use, {
            method: "POST",
            body: options,
        });
    }
}
